import { useCreateMutation } from '../../CRUD';
import { VerifyInsuranceData } from './types';
import { axiosService } from '../../services/axiosService';
import { insuranceBaseModel } from './crud';

export const useVerifyInsurance = () => {
  async function queryFn(verifyInsuranceData: VerifyInsuranceData) {
    const { data } = await axiosService.request({
      url: `${insuranceBaseModel.keys.basicUrlPath}/${verifyInsuranceData.id}/verify`,
      method: 'post',
      data: verifyInsuranceData,
    });
    return data;
  }

  return useCreateMutation(
    insuranceBaseModel.keys.all,
    queryFn,
    insuranceBaseModel.keys.fetchKey,
  );
};
